var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c("Loading", { attrs: { text: "Lade Ausschlüsse..." } })
        : [
            _vm.exclusions.length === 0
              ? _c("JonInfo", {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "message",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n\t\t\t\tEs sind noch keine Einträge vorhanden.\n\t\t\t"
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2596878449
                  )
                })
              : _c(
                  "div",
                  { staticClass: "items-list" },
                  [
                    _vm._l(_vm.exclusions, function(exclusion) {
                      return _c("ListItem", {
                        key: exclusion.id,
                        attrs: { exclusion: exclusion },
                        on: { remove: _vm.loadExclusions }
                      })
                    }),
                    _vm._v(" "),
                    _c("Pagination", {
                      staticClass: "mb-4",
                      attrs: {
                        page: _vm.page,
                        total: _vm.meta.total,
                        "items-per-page": _vm.itemsPerPage
                      },
                      on: { input: _vm.loadExclusions },
                      model: {
                        value: _vm.page,
                        callback: function($$v) {
                          _vm.page = $$v
                        },
                        expression: "page"
                      }
                    })
                  ],
                  2
                )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }